<template>
  <v-card>
    <v-card-title>
      <v-toolbar-title>
        <slot/>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-dialog v-model="dialog">
        <v-dialog v-model="noEmpChosen" hide-overlay persistent width="300">
          <v-card dark tile text color="error" text-xs-center>
            <v-card-text>No employees selected</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" text @click="noEmpChosen = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-card>
          <v-card-text>
            <employee-list
              v-if="selected.length > 0"
              ref="empList"
              :employees="employees"
              @GetSelectedEmp="selectedEmployee=$event"
              :isEditable="false"
              :isSelectable="true"
              @editEmployee="editEmployee($event)"
              :selected="selected"
            >Choose employee to move order to</employee-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-row align="end" justify="end" >
              <v-btn color="primary" @click="SaveToEmployee()" :disabled="selectedEmployee==0">Move</v-btn>
              <v-btn color="light-grey" @click="dialog=false;">Cancel</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      v-if="orders"
      v-model="selected"
      :headers="headers"
      :items="orders"
      class="elevation-1"
      item-key="orderID"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td
          :class="`text-xs-${name.align}`"
          v-for="(name, index) in headers.filter(x => x.text !== 'Actions')"
          :key="index"
        >
          <v-checkbox v-if="name.value == 'select'" v-model="props.selected" primary hide-details></v-checkbox>
          <div v-if="isDateColumn(name.value)">{{props.item[name.value] | formatDate}}</div>
          <div v-else>
            <div v-if="name.value == 'dealerDetails'">{{ props.item[name.value]['dealerFullName'] }}</div>
            <div v-else>
              <div v-if="name.value == 'orderStatus'">{{ props.item[name.value] | orderStatus}}</div>
              <div v-else>{{ props.item[name.value] }}</div>
            </div>
          </div>
        </td>
      </template>
    </v-data-table>

    <v-btn color="primary" @click="showSelected" :disabled="selected.length==0">Move Order</v-btn>
  </v-card>
</template>

<script>
import employees from "@/helpers/mockEmployees.json";
import employeeList from "@/components/employee/employee-list.vue";

import { createNamespacedHelpers } from "vuex";
const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);

export default {
  mame: "CustomerOrders",
  components: {
    employeeList
  },
  data() {
    return {
      search: "",
      selected: [],
      orders: null,
      selectedEmployee: 0,
      editIndex: 0,
      employees: employees,
      dialog: false,
      noEmpChosen: false
    };
  },
  computed: {
    headers: function() {
      if (this.orders) {
        let header = this.getHeaders(this.orders[0]).filter(
          x => x.text !== "Actions"
        );
        return [
          { align: "left", sortable: false, text: "Select", value: "select" },
          ...header
        ];
      } else return null;
    }
  },
  methods: {
    ...mapOrderActions([
      "GetAllOrdersForDealer",
      "MoveOrdertoEmployee",
      "MoveCustomertoEmployee"
    ]),

    showSelected() {
      this.dialog = !this.dialog;
    },
    // GetEmployees(event)
    // {
    //   this.selectedEmployee=event;
    //   console.log("Selected Employee is:\t" + this.selectedEmployee);
    // },
    async SaveToEmployee() {
      let vm = this;
      for (const order of vm.selected) {
        await vm.MoveOrdertoEmployee({
          dealerID: this.selectedEmployee[0],
          orderID: order.orderID
        });
      }
      vm.dialog = false;
      vm.refresh();
    },
    refresh() {
      let vm = this;
      this.GetAllOrdersForDealer().then(data => {
        vm.orders = data;
      });
    }
  },
  mounted() {
    this.refresh();
  }
};
</script>

<style scoped>
</style>
